import React, { useState } from "react";
import "./NotFound.scss";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";

const PageNotFound = () => {
  const handleGoBack = () => {
    window.history.back();
  };

  const handleReportProblem = () => {
    window.open(
      "mailto:support@example.com?subject=404 Error Report",
      "_blank"
    );
  };
  return (
    <div className="container text-center not-found-container">
      <div className="row justify-content-center">
        <div className="col-md-6 col-lg-8">
          <div className="not-found-content">
            <div className="icon-container">
              <div className="hexagon">
                <div className="face">
                  <div className="eye left"></div>
                  <div className="eye right"></div>
                  <div className="mouth"></div>
                </div>
              </div>
            </div>

            <h1 className="not-found-title">404</h1>
            <h2 className="not-found-subtitle">This template didn't load!</h2>

            <p className="not-found-description">
              The page you're looking for doesn't seem to exist. But don't
              worry, we've got plenty of amazing templates waiting for you!
            </p>

            <div className="action-button">
              <button className="btn back-btn me-3" onClick={handleGoBack}>
                <KeyboardBackspaceIcon />
                Go back
              </button>

              <button
                className="btn  Report-btn "
                onClick={handleReportProblem}
              >
                <ErrorOutlineIcon />
                Report problem
              </button>
            </div>

            <div className="footer">
              <div className="help-text">
                <HelpOutlineOutlinedIcon />
                <span>Need help? Reach out to us at </span>
                <a href="mailto:support@example.com" className="footer-link">
                  support@example.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;
